export default __webpack_public_path__ + "static/media/security.a3655cc4.svg";